import React, { useEffect, useState } from 'react';
import { useAtlasStore, AtlasState } from '../store/atlasStore'; // Adjust path if needed

interface PdfLightboxProps {
  url: string | undefined;
  initialPage?: number;
  onClose: () => void;
}

export const PdfLightbox: React.FC<PdfLightboxProps> = ({ url, initialPage, onClose }) => {
  const [isLoading, setIsLoading] = useState(true);
  const setSparkUserInteractionBlockingRefresh = useAtlasStore((state: AtlasState) => state.setSparkUserInteractionBlockingRefresh);

  // Effect to block/unblock refresh when lightbox is open (based on url presence)
  useEffect(() => {
    if (url) {
      setSparkUserInteractionBlockingRefresh(true);
      // Cleanup when URL becomes undefined or component unmounts
      return () => {
        setSparkUserInteractionBlockingRefresh(false);
      };
    }
  }, [url, setSparkUserInteractionBlockingRefresh]);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  if (!url) return null;

  return (
    <div className="pdf-lightbox-overlay" onClick={onClose}>
      <div className="pdf-lightbox-content" onClick={e => e.stopPropagation()}>
        <button className="pdf-lightbox-close" onClick={onClose}>×</button>
        {isLoading && (
          <div className="pdf-lightbox-loading">Loading PDF...</div>
        )}
        <iframe
          src={`${url}${initialPage ? '#page=' + initialPage : ''}`}
          className="pdf-lightbox-iframe"
          title={`PDF preview${initialPage ? ` starting at page ${initialPage}` : ''}`}
          onLoad={() => setIsLoading(false)}
        />
      </div>
    </div>
  );
}; 
